<template>
  <custom-callout
    class="mb-4"
    :border-color="getColor(detail.statusId)"
    :show-edition="showSelections"
  >
    <div class="row">
      <div
        class="col-sm d-flex w-border justify-content-center balloon-center border-right"
      >
        <div class="w-balloon-fixed">
          <custom-balloon-light
            class="p-2 mb-2"
            :with-border="false"
            :bg="`bg-${getColor(detail.statusId)}`"
            :text="detail.statusDesc"
          />
        </div>
      </div>
      <div class="col-sm">
        <span v-if="detail.initialRegisterFlag == '1'" class="body-2 text-gray">
          Número de Registro:
        </span>
        <p
          v-if="detail.initialRegisterFlag == '1'"
          class="body-1 font-weight-normal"
        >
          {{ detail.formattedId }}
        </p>
      </div>
       <div class="col-sm">
        <span class="body-2 text-gray">Creado:</span>
        <p>
          {{ $formatDate(detail.createDate) }} - {{ detail.creatByFullName }}
        </p>
      </div>
      <div class="col-sm">
        <span class="body-2 text-gray">Modificado:</span>
        <p v-if="detail.modifyDate">
          {{ $formatDate(detail.modifyDate) }} - {{ detail.modifyByFullName }}
        </p>
        <p v-else>
          -
        </p>
      </div>
      <div class="col-sm">
        <div
          class="d-flex justify-content-sm-start justify-content-md-end mr-4 h-100 align-content-center"
        >
          <DropDown
            :fix-width="false"
            :items="getMenuItems()"
            @goPrint="showSelections = true"
            @goEdit="editHistoryRegistry"
            @goDelete="deleteHistoryRegistry"
          />
        </div>
      </div>
    </div>
    <div
      v-if="detail.initialRegisterFlag == '1'"
      class="bg-white top board-radius--4px p-2"
    >
      <div class="row mb-2">
        <div class="col-sm">
          <em class="fas fa-info-circle text-orange" />
          <span class="ml-2">Datos de Referido</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <div class="ml-4">
            <span class="body-2 text-gray">Tipo:</span>
            <p class="body-1 font-weight-normal">
              {{ detail.locationTypeDesc }}
            </p>
          </div>
        </div>
        <div class="col-sm data-left">
          <span class="body-2 text-gray">Lugar:</span>
          <p class="body-1 font-weight-normal">
            {{ detail.userLocationCodeDesc }}
          </p>
        </div>
        <div class="col-sm data-left">
          <span class="body-2 text-gray">Región:</span>
          <p class="body-1 font-weight-normal">
            {{ detail.regionName }}
          </p>
        </div>
        <div class="col-sm data-left">
          <span class="body-2 text-gray">Distrito:</span>
          <p class="body-1 font-weight-normal">
            {{ detail.districtName }}
          </p>
        </div>
        <div class="col-sm data-left">
          <span class="body-2 text-gray">Escuela:</span>
          <p class="body-1 font-weight-normal">
            {{ detail.schoolName }}
          </p>
        </div>
      </div>
    </div>
    <template #edition>
      <div class="row mb-2 mx-3 mt-2">
        <div class="col-sm mb-3">
          <em class="fas fa-folders rounded-circle shadow text-orange p-2" />
          <span class="ml-2 font-weight-bold">Selección de Formularios</span>
        </div>
        <div class="col-sm">
          <div
            class="d-flex justify-content-md-end justify-content-sm-start mb-2"
          >
            <custom-link
              text="Remover toda selección"
              icon="fas fa-minus-circle"
              @click="setAllFormTypesValues(false)"
            />

            <custom-link
              class="mx-3"
              text="Seleccionar todos"
              icon="fas fa-plus-circle"
              @click="setAllFormTypesValues(true)"
            />
          </div>
        </div>
      </div>
      <div class="row mx-3">
        <div
          v-for="(item, idx) in availableFormTypes"
          :key="idx"
          class="col-sm-12 col-md-4"
        >
          <custom-checkbox
            :id="item.id"
            :value="item.selected"
            :text="item.name"
            @onChange="item.selected = $event"
          />
        </div>
      </div>
      <div class="row m-3">
        <div
          class="d-flex justify-content-md-end justify-content-sm-start w-100"
        >
          <action-button
            text="Cancelar"
            variant="outline-danger"
            i="fas fa-times-circle"
            @click="hideFormTypesPanel"
          />
          <action-button
            class="mx-3"
            text="Procesar"
            variant="success"
            i="fas fa-print"
            @click="downloadForms"
          />
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapMutations } = createNamespacedHelpers('$_student');
import DropDown from '@/components/common/menu/DropDown';
import StudentStatuses from '@/utils/constants/student/studentStatuses';
import alert from '@/mixin/alert.mixin';
import store from '@/store/index';
import resourcesService from '@/services/resources.js';
import statusColorMixin from './statusColor';
import DocumentsService from '@/services/documents';
import CustomRadioGroup from '@/components/common/CustomRadio';

import {
  CustomCallout,
  CustomBalloonLight,
  CustomLink,
  CustomCheckbox,
  ActionButton,
} from '@/components/common';

export default {
  name: 'HistoryItem',
  mixins: [alert, statusColorMixin],
  components: {
    DropDown,
    CustomCallout,
    CustomBalloonLight,
    CustomLink,
    CustomCheckbox,
    ActionButton,
    CustomRadioGroup,
  },
  props: {
    formTypes: {
      type: Array,
      default: () => [],
    },
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      resources: [],
      showSelections: false,
    };
  },
  methods: {
    ...mapMutations(['setStudentPreRegistry']),
    setAllFormTypesValues(value) {
      this.availableFormTypes.forEach((item) => {
        item.selected = value;
      });
    },
    hideFormTypesPanel() {
      this.setAllFormTypesValues(false);
      this.showSelections = false;
    },
    getMenuItems() {
      let items = [
        {
          Title: 'Editar',
          Icon: 'fa fa-pencil',
          IconColor: 'text-green',
          Type: 'Menu',
          EmitGo: 'goEdit',
          Children: [],
        },
        {
          Title: 'Paquete de Formularios',
          Icon: 'fa fa-print',
          IconColor: 'text-green',
          Type: 'Menu',
          EmitGo: 'goPrint',
          Children: [],
          Visible:
            this.detail.statusId != StudentStatuses.PreRegistro &&
            this.detail.statusId != StudentStatuses.Disponible &&
            this.detail.initialRegisterFlag == '1',
        },
        {
          Title: 'Eliminar',
          Icon: 'fas fa-times-circle',
          IconColor: 'text-red',
          Type: 'Menu',
          EmitGo: 'goDelete',
          Children: [],
          Visible: this.hasPermissionStudentsRegistryDelete,
        },
      ];
      return items;
    },
    // Event hanlder.
    // On click edit event.
    async editHistoryRegistry() {
      let detail = this.detail;
      //set state data
      this.setStudentPreRegistry({
        regStudentId: store.getters.SelectedStudent.regStudentId,
        regStudentPostRegistryId: detail.isPostRegistry ? detail.regId : null,
        academicYearId: detail.academicYearId,
        statusId: detail.statusId,
        isInitialRegistry: detail.initialRegisterFlag,
        isReadMode: this.evalIsReadMode(detail.statusId),
        isReadModePostRegistry: this.evalIsReadModePostRegistry(
          detail.statusId
        ),
        isPostRegistry: detail.isPostRegistry,
        hasInitialEvaluationFlag: detail.hasInitialEvaluationFlag,
      });
      //redirect to master
      this.$router.push('/student/registrygeneral');
    },
    async deleteHistoryRegistry() {
      let self = this;

      // If there are validations, it does not allow deletion.
      if (this.detail.validationDelete.length > 0) {
        self.ShowToast(
          'Error',
          this.resources['136'].format(this.detail.validationDelete),
          'error'
        );
        return;
      }

      const response = await alert.methods.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el registro?',
        'Sí',
        'No'
      );

      if (response) {
        return new Promise((resolve) => {
          const id = this.detail.isPostRegistry ? this.detail.id : this.detail.regId;
          self
            .$ApiDelete(`api/studentregistry/${id}`)
            .then((res) => {
              this.$emit('deleteHistoryItem');
              resolve(res.data);
            })
            .catch(() => {
              self.ShowToast('Error', this.resources['R03200108'], 'error');
            });
        });
      }
    },
    stringFormat() {
      String.prototype.format = function() {
        let self = this;
        for (let k in arguments) {
          self = self.replace(new RegExp('\\{' + k + '\\}', 'g'), arguments[k]);
        }
        return self;
      };
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '136',
        'R03200108',
        'R160001',
      ]);
    },
    evalIsReadMode(statusId) {
      return (
        statusId != StudentStatuses.PreRegistro &&
        statusId != StudentStatuses.Disponible
      );
    },
    evalIsReadModePostRegistry(statusId) {
      return statusId === StudentStatuses.Servido;
    },
    async downloadForms() {
      let self = this;

      if (!self.formTypes.some((x) => x.selected)) {
        self.ShowToast('Error', this.resources['R160001'], 'error');
        return;
      }

      let selectedFormTypes = self.formTypes.filter((x) => x.selected);
      let qrs = '';

      for (let i = 0; i < selectedFormTypes.length; i++) {
        const formType = selectedFormTypes[i];

        qrs += `codes=${formType.id}&`;
      }

      qrs = qrs.slice(0, -1);

      let registryFormsUrl = `/api/report/registryforms/${store.getters.SelectedStudent.studentId}/${self.detail.regId}/PDF?${qrs}`;

      let promise = new Promise((resolve) => {
        self
          .$ApiGet(registryFormsUrl)
          .then((res) => {
            DocumentsService.Download(res.data);
            resolve(res.data);
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              self.ShowToast('Error', err.response.data.message, 'error');
            } else {
              self.ShowToast('Error', err.message, 'error');
            }
          });
      });
      return promise;
    },
  },
  computed: {
    hasPermissionStudentsRegistryDelete() {
      return store.getters.HasPermission('students.registry.delete');
    },
    availableFormTypes() {
      return this.formTypes;
    },
  },
  async mounted() {
    this.stringFormat();
    this.loadResources();
  },
};
</script>

<style scoped>
a i.fas.fa-exclamation-triangle {
  color: #ff5b5c;
}
a.active i.fas.fa-exclamation-triangle {
  color: white;
}
.header {
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}
.text-fix {
  font-weight: 400;
}
.registry-status {
  background: #a3e5b3 0% 0% no-repeat padding-box;
  border-radius: 26px;
  opacity: 1;
  width: 189px;
  height: 37px;
}
.state-green {
  background: #a3e5b3;
}
.state-yellow {
  background: #f8eb7f;
}
.state-red {
  background: #fcc9c8;
}
.row-odd {
  background-color: #fafbfa;
}
.row-even {
  background-color: #ffffff;
}
.btn-green {
  border: 1px solid #2db782;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}
.dropdown-item {
  font: Regular 16px/19px Lato;
}
.dropdown-item i {
  margin-right: 1rem;
}
.empty-registry-text {
  color: #727272;
}

.top {
  position: relative;
  top: 10px;
}

.w-balloon-fixed {
  width: 180px;
}

@media screen and (max-width: 575px) {
  .w-border {
    border-right: none !important;
  }

  .data-left {
    margin-left: 1.5rem !important;
  }

  .balloon-center {
    justify-content: start !important;
  }
}
</style>
